import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApprovalTimelineData } from './approval-timeline.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ApprovalTimelineComponent } from './approval-timeline.component';

@Component({
  selector: 'app-approval-timeline-dialog',
  templateUrl: './approval-timeline-dialog.component.html',
  styleUrls: ['./approval-timeline-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, ApprovalTimelineComponent]
})
export class ApprovalTimelineDialogComponent {
  approvalData: ApprovalTimelineData;

  constructor(
    public dialogRef: MatDialogRef<ApprovalTimelineDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { approvalData: ApprovalTimelineData }
  ) {
    this.approvalData = data.approvalData;
  }

  onClose(): void {
    this.dialogRef.close();
  }
} 